/* Keyteks: banner (titulo / mosaico de productos / super oferta), cuentas regresivas, entrega hoy, franja rotativa,
   carrusel de ofertas automatico, ventanas de informacion, mapa de cobertura e icono de 10%. */
(function () {
  function buildSlides() {
    var slider = document.querySelector("#MainContent [id^='Slider-'].slideshow");
    if (!slider) return;
    var slides = slider.querySelectorAll('.slideshow__slide');
    slides.forEach(function (slide, i) {
      var tw = slide.querySelector('.slideshow__text-wrapper');
      if (!tw || slide.classList.contains('kt-ready')) return;
      var heading = tw.querySelector('.banner__heading');
      var btn = tw.querySelector('.banner__buttons a');
      var sub = tw.querySelector('.banner__text');

      var st = document.createElement('div');
      st.className = 'kt-st';
      var h = document.createElement('h2');
      h.textContent = heading ? heading.textContent.trim() : '';
      st.appendChild(h);
      if (btn && btn.getAttribute('href')) {
        var a = document.createElement('a');
        a.href = btn.getAttribute('href');
        a.textContent = btn.textContent.trim() + ' ›';
        st.appendChild(a);
      }

      var of = document.createElement('div');
      of.className = 'kt-sof';
      var tpl = document.querySelector('template[data-kt-offer="' + (i + 1) + '"]');
      if (tpl) {
        of.appendChild(tpl.content.cloneNode(true));
      } else if (sub && sub.textContent.trim()) {
        var p = document.createElement('p');
        p.className = 'kt-sub';
        p.textContent = sub.textContent.trim();
        of.appendChild(p);
      }

      /* Mosaico de productos con stock en lugar de la foto (si hay al menos 3) */
      var mt = document.querySelector('template[data-kt-mosaic="' + (i + 1) + '"]');
      var media = slide.querySelector('.slideshow__media');
      if (mt && media) {
        var mo = document.createElement('div');
        mo.className = 'kt-mos';
        mo.appendChild(mt.content.cloneNode(true));
        if (mo.querySelectorAll('.kt-mo').length >= 3) media.appendChild(mo);
      }

      slide.insertBefore(st, slide.firstChild);
      slide.appendChild(of);
      slide.classList.add('kt-ready');
    });
    slider.classList.add('kt-on');

    /* Mientras el dedo esta sobre el banner se detiene el cambio automatico (evita que se trabe) */
    var comp = slider.closest('slideshow-component');
    var back;
    if (comp) {
      slider.addEventListener('touchstart', function () {
        clearTimeout(back);
        if (typeof comp.pause === 'function') comp.pause();
      }, { passive: true });
      slider.addEventListener('touchend', function () {
        clearTimeout(back);
        back = setTimeout(function () {
          if (typeof comp.play === 'function' && slider.getAttribute('data-autoplay') === 'true') comp.play();
        }, 6000);
      }, { passive: true });
    }
  }

  function pad(n) { return (n < 10 ? '0' : '') + n; }

  function startTimers() {
    var timers = document.querySelectorAll('.kt-timer[data-end]');
    if (!timers.length) return;
    function tick() {
      var now = Date.now();
      timers.forEach(function (t) {
        var end = Date.parse(t.getAttribute('data-end'));
        var out = t.querySelector('b');
        if (isNaN(end) || !out) { t.style.display = 'none'; return; }
        var d = Math.floor((end - now) / 1000);
        if (d <= 0) { t.style.display = 'none'; return; }
        var days = Math.floor(d / 86400);
        var hh = Math.floor((d % 86400) / 3600);
        var mm = Math.floor((d % 3600) / 60);
        var ss = d % 60;
        out.textContent = (days > 0 ? days + 'd ' : '') + pad(hh) + ':' + pad(mm) + ':' + pad(ss);
      });
    }
    tick();
    setInterval(tick, 1000);
  }

  /* Entrega el mismo dia: compras antes de las 15:00 (hora de Chile), Santiago urbano */
  var CUTOFF_HOUR = 15;
  function chileMinutes() {
    try {
      var parts = new Intl.DateTimeFormat('en-GB', { timeZone: 'America/Santiago', hour: '2-digit', minute: '2-digit', hour12: false }).formatToParts(new Date());
      var h = 0, m = 0;
      parts.forEach(function (p) { if (p.type === 'hour') h = parseInt(p.value, 10) % 24; if (p.type === 'minute') m = parseInt(p.value, 10); });
      return h * 60 + m;
    } catch (e) { return null; }
  }
  function sameDayHtml() {
    var now = chileMinutes();
    if (now === null) return null;
    var left = CUTOFF_HOUR * 60 - now;
    if (left > 0) {
      var h = Math.floor(left / 60), m = left % 60;
      var t = (h > 0 ? h + ' h ' : '') + m + ' min';
      return 'Pide en <b>' + t + '</b> y recíbelo <b>hoy</b> en Santiago urbano';
    }
    return 'Pide ahora y recíbelo <b>mañana</b> en Santiago urbano';
  }
  function sameDay() {
    var html = sameDayHtml();
    if (!html) return;
    var targets = [];
    var pp = document.querySelector('.kt-pp');
    if (pp) {
      var box = document.createElement('div');
      box.className = 'kt-sd';
      box.innerHTML = "<svg viewBox='0 0 24 24'><path d='M13 2 4 14h7l-1 8 9-12h-7z'/></svg><span></span>";
      pp.parentNode.insertBefore(box, pp);
      targets.push(box.querySelector('span'));
    }
    document.querySelectorAll('.kt-rot').forEach(function (rot) {
      var s = document.createElement('span');
      var on = rot.querySelector('.on');
      if (on) on.classList.remove('on');
      s.className = 'on';
      s.setAttribute('data-kt-key', 'hoy');
      rot.insertBefore(s, rot.firstChild);
      targets.push(s);
    });
    function paint() {
      var h = sameDayHtml();
      if (h) targets.forEach(function (t) { t.innerHTML = h; });
    }
    paint();
    setInterval(paint, 30000);
  }

  function norm(s) {
    s = String(s || '').toLowerCase();
    if (s.normalize) s = s.normalize('NFD').replace(/[̀-ͯ]/g, '');
    return s.replace(/[^a-z ]/g, ' ').replace(/\s+/g, ' ').trim();
  }

  /* Franja de mensajes: cambia cada 5 segundos y cada mensaje abre su ventana */
  function rotate() {
    document.querySelectorAll('.kt-rot').forEach(function (r) {
      var k = r.children, i = 0;
      Array.prototype.forEach.call(k, function (el) {
        var key = el.getAttribute('data-kt-key');
        if (!key) {
          var t = norm(el.textContent);
          if (t.indexOf('envio gratis') > -1) key = 'envio';
          else if (t.indexOf('entrega hoy') > -1) key = 'hoy';
          else if (t.indexOf('mercadolider') > -1) key = 'meli';
          else if (t.indexOf('garantia') > -1) key = 'garantia';
        }
        if (key && document.getElementById('kt-m-' + key)) {
          el.setAttribute('data-kt-modal', key);
          el.setAttribute('role', 'button');
          el.setAttribute('tabindex', '0');
        }
      });
      if (k.length < 2) return;
      setInterval(function () {
        k[i].classList.remove('on');
        i = (i + 1) % k.length;
        k[i].classList.add('on');
      }, 5000);
    });
  }

  function autoCarousel() {
    if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    var list = document.querySelector('#MainContent slider-component .product-grid.slider');
    if (!list) return;
    var paused = false, resume, lastLeft = -1, rewinding = false;
    function hold(ms) {
      paused = true;
      clearTimeout(resume);
      if (ms) resume = setTimeout(function () { paused = false; }, ms);
    }
    function rewind() {
      if (rewinding) return;
      rewinding = true;
      list.classList.add('kt-fade');
      setTimeout(function () {
        list.style.scrollSnapType = 'none';
        list.style.scrollBehavior = 'auto';
        list.scrollLeft = 0;
        lastLeft = -1;
        setTimeout(function () {
          list.style.scrollSnapType = '';
          list.style.scrollBehavior = '';
          list.classList.remove('kt-fade');
          rewinding = false;
        }, 80);
      }, 360);
    }
    list.addEventListener('mouseenter', function () { hold(0); });
    list.addEventListener('mouseleave', function () { paused = false; });
    list.addEventListener('touchstart', function () { hold(8000); }, { passive: true });
    list.addEventListener('focusin', function () { hold(8000); });
    setInterval(function () {
      if (paused || rewinding || document.hidden) return;
      var r = list.getBoundingClientRect();
      if (r.bottom < 0 || r.top > window.innerHeight) return;
      var items = list.querySelectorAll('.grid__item');
      var item = null;
      for (var j = 0; j < items.length; j++) { if (items[j].offsetWidth > 0) { item = items[j]; break; } }
      if (!item) return;
      var gap = parseFloat(getComputedStyle(list).columnGap) || 0;
      var step = item.offsetWidth + gap;
      var left = list.scrollLeft;
      var atEnd = left + list.clientWidth >= list.scrollWidth - 8;
      var stuck = lastLeft >= 0 && Math.abs(left - lastLeft) < 2;
      if (atEnd || stuck) {
        rewind();
      } else {
        lastLeft = left;
        list.scrollBy({ left: step, behavior: 'smooth' });
      }
    }, 4500);
  }

  /* Ventanas de informacion: cualquier elemento con data-kt-modal='id' abre <dialog id='kt-m-id'> */
  function modals() {
    function open(el, e) {
      var d = document.getElementById('kt-m-' + el.getAttribute('data-kt-modal'));
      if (d && typeof d.showModal === 'function') { e.preventDefault(); if (!d.open) d.showModal(); }
    }
    document.addEventListener('click', function (e) {
      var opener = e.target.closest ? e.target.closest('[data-kt-modal]') : null;
      if (opener) { open(opener, e); return; }
      var closer = e.target.closest ? e.target.closest('[data-kt-close]') : null;
      if (closer) { var dlg = closer.closest('dialog'); if (dlg) dlg.close(); return; }
      if (e.target.tagName === 'DIALOG' && e.target.classList.contains('kt-modal')) e.target.close();
    });
    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Enter' && e.key !== ' ') return;
      var el = e.target;
      if (el && el.getAttribute && el.getAttribute('data-kt-modal') && el.tagName !== 'BUTTON') open(el, e);
    });
  }

  /* Cobertura de entrega el mismo dia (comunas de Flex). [nombre, columna, fila] en una grilla de 6 columnas */
  var COMUNAS = [
    ['Colina', 4, 1],
    ['Quilicura', 3, 2], ['Huechuraba', 4, 2], ['Lo Barnechea', 6, 2],
    ['Pudahuel', 1, 3], ['Renca', 2, 3], ['Conchalí', 3, 3], ['Recoleta', 4, 3], ['Vitacura', 5, 3], ['Las Condes', 6, 3],
    ['Cerro Navia', 1, 4], ['Quinta Normal', 2, 4], ['Independencia', 3, 4], ['Providencia', 4, 4], ['Ñuñoa', 5, 4], ['La Reina', 6, 4],
    ['Lo Prado', 1, 5], ['Estación Central', 2, 5], ['Santiago', 3, 5], ['San Joaquín', 4, 5], ['Macul', 5, 5], ['Peñalolén', 6, 5],
    ['Maipú', 1, 6], ['Cerrillos', 2, 6], ['Pedro Aguirre Cerda', 3, 6], ['San Miguel', 4, 6], ['La Granja', 5, 6], ['La Florida', 6, 6],
    ['Padre Hurtado', 1, 7], ['Lo Espejo', 2, 7], ['La Cisterna', 3, 7], ['San Ramón', 4, 7], ['La Pintana', 5, 7], ['Puente Alto', 6, 7],
    ['San Bernardo', 2, 8], ['El Bosque', 3, 8]
  ];
  var SHORT = { 'Pedro Aguirre Cerda': 'P. Aguirre Cerda' };
  var ALIAS = { 'santiago centro': 'santiago', 'stgo': 'santiago', 'santiago de chile': 'santiago', 'las condes de santiago': 'las condes', 'pac': 'pedro aguirre cerda', 'chicureo': 'colina', 'la dehesa': 'lo barnechea' };
  function findComuna(text) {
    var q = norm(text);
    if (!q) return null;
    if (ALIAS[q]) q = ALIAS[q];
    for (var i = 0; i < COMUNAS.length; i++) if (norm(COMUNAS[i][0]) === q) return COMUNAS[i];
    return null;
  }
  function coverage() {
    document.querySelectorAll('[data-kt-cov]').forEach(function (box) {
      var input = box.querySelector('input');
      var out = box.querySelector('.kt-cov__r');
      var map = box.querySelector('.kt-cov__m');
      var list = box.querySelector('datalist');
      if (!input || !out || !map) return;
      var tiles = {};
      COMUNAS.forEach(function (c) {
        var b = document.createElement('button');
        b.type = 'button';
        b.title = c[0];
        b.lang = 'es';
        b.style.gridColumn = String(c[1]);
        b.style.gridRow = String(c[2]);
        b.textContent = SHORT[c[0]] || c[0];
        b.addEventListener('click', function () { input.value = c[0]; show(c[0], false); });
        map.appendChild(b);
        tiles[c[0]] = b;
        if (list) { var o = document.createElement('option'); o.value = c[0]; list.appendChild(o); }
      });
      function show(text, mine) {
        Object.keys(tiles).forEach(function (k) { tiles[k].classList.remove('is-on'); });
        out.classList.remove('is-yes', 'is-no');
        var clean = String(text || '').trim();
        if (clean.length < 3) { out.textContent = 'Escribe tu comuna o tócala en el mapa.'; return; }
        var c = findComuna(clean);
        if (c) {
          tiles[c[0]].classList.add('is-on');
          out.classList.add('is-yes');
          out.textContent = (mine ? 'Tu dirección en ' + c[0] + ' está dentro de la cobertura: ' : 'Sí, llegamos a ' + c[0] + ': ') + 'comprando antes de las 15:00 lo recibes hoy.';
        } else {
          out.classList.add('is-no');
          out.textContent = (mine ? 'Tu dirección en ' + clean + ' queda fuera de la entrega el mismo día. ' : 'Por ahora no tenemos entrega el mismo día en ' + clean + '. ') + 'Te lo enviamos por despacho normal a todo Chile.';
        }
      }
      input.addEventListener('input', function () { show(input.value, false); });
      var city = box.getAttribute('data-city');
      if (city) { input.value = city; show(city, true); } else { show('', false); }
    });
  }

  /* Icono de 10% (teaser de Shopify Forms) sobre el de WhatsApp; la primera visita muestra el mensaje */
  var FORMS_CSS = '#app-embed[data-current-step=tease]{top:auto!important;bottom:84px!important;right:24px!important;left:auto!important;transform:none!important;rotate:0deg!important;padding:0!important;width:auto!important}' +
    '#app-embed[data-current-step=tease] [data-testid=app-router]{rotate:0deg!important;transform:none!important}' +
    '#app-embed[data-current-step=tease] [data-testid=form-teaser]{position:relative;overflow:visible!important;display:flex!important;align-items:center;justify-content:center;width:48px!important;height:48px!important;min-width:0!important;padding:0!important;border-radius:50%!important;background:#e11d48!important;border:0!important;box-shadow:0 4px 12px rgba(0,0,0,.3)!important;cursor:pointer}' +
    '#app-embed[data-current-step=tease] [data-testid=form-teaser] h3{font-size:0!important;margin:0!important;line-height:1!important;width:34px}' +
    '#app-embed[data-current-step=tease] [data-testid=form-teaser] h3::before{content:"10% OFF";display:block;font:700 12px/1.05 Arial,sans-serif;color:#fff;text-align:center}' +
    '#app-embed[data-current-step=tease] [aria-label="Close modal"]{display:none!important}' +
    ':host([data-kt-first]) #app-embed[data-current-step=tease] [data-testid=form-teaser]::after{content:"10% de descuento en tu primera compra";position:absolute;right:58px;top:50%;transform:translateY(-50%);background:#e11d48;color:#fff;font:600 13px/1.2 Arial,sans-serif;padding:8px 12px;border-radius:20px;white-space:nowrap;box-shadow:0 2px 8px rgba(0,0,0,.25);animation:ktLbl .5s ease 7s forwards}' +
    '@keyframes ktLbl{to{opacity:0;visibility:hidden}}' +
    '@media (max-width:749px){#app-embed[data-current-step=tease]{bottom:72px!important;right:14px!important}}';
  function formsIcon() {
    var first = false;
    try {
      if (!localStorage.getItem('kt_off_seen')) { first = true; localStorage.setItem('kt_off_seen', '1'); }
    } catch (e) {}
    var n = 0;
    var t = setInterval(function () {
      var f = document.querySelector('shopify-forms-embed');
      var root = f && f.shadowRoot;
      var app = root && root.querySelector('#app-embed');
      if (app) {
        clearInterval(t);
        if (!root.querySelector('#kt-forms')) {
          var s = document.createElement('style');
          s.id = 'kt-forms';
          s.textContent = FORMS_CSS;
          root.appendChild(s);
        }
        if (first) f.setAttribute('data-kt-first', '');
        /* El formulario de suscripcion solo se abre si la persona toca el icono (no al entrar al sitio) */
        var userOpened = false;
        root.addEventListener('click', function (e) {
          if (e.target.closest && e.target.closest('[data-testid=form-teaser]')) userOpened = true;
        }, true);
        if (window.MutationObserver) {
          var guard = function () {
            var step = app.getAttribute('data-current-step');
            if (step === 'tease') { userOpened = false; return; }
            if (!userOpened) {
              var x = root.querySelector('[aria-label="Close modal"]');
              if (x) x.click();
            }
          };
          new MutationObserver(guard).observe(app, { attributes: true, attributeFilter: ['data-current-step'] });
          guard();
        }
        return;
      }
      if (++n > 60) clearInterval(t);
    }, 500);
  }

  /* Ficha de producto: medios de pago con logos, combos cafetera <-> Aeroccino y botón de compra fijo en celular */ function ktPdp() { var form = document.querySelector('product-form'); if (!form) return; var btn = form.querySelector('button[name=add]'), wrap = form.querySelector('.product-form__buttons'); if (!btn || !wrap) return; var AERO = 'espumador-de-leche-nespresso-aeroccino-3-automatico-color-negro'; var CAFES = ['cafetera-nescafe-dolce-gusto-genio-s-blanca', 'cafetera-nespresso-essenza-mini-negra', 'cafetera-nespresso-inissia-roja', 'cafetera-nespresso-inissia-color-negro', 'cafetera-nescafe-dolce-gusto-piccolo-xs-negra', 'cafetera-nespresso-pixie-titan', 'cafetera-nespresso-vertuo-pop-negro', 'cafetera-nespresso-vertuo-pop-blanco', 'cafetera-espresso-nespresso-vertuo-pop-rojo']; var css = document.createElement('style'); css.textContent = '.product__info-container>.kt-pago-nota{display:none!important}' + '.kt-pay{display:flex;flex-wrap:wrap;gap:8px;align-items:center;margin:14px 0 0;padding:12px 14px;border:1px solid #e3e5f0;border-radius:12px;background:#fafbff}' + '.kt-pay__l{flex-basis:100%;display:flex;align-items:center;gap:6px;font-size:1.3rem;font-weight:700;color:#2D3277}' + '.kt-pay__l svg{width:15px;height:15px;fill:#4eae32}' + '.kt-pay__g{height:28px;width:auto;display:block;border-radius:4px}' + '.kt-pay__n{flex-basis:100%;font-size:1.2rem;line-height:1.4;color:#666;margin:2px 0 0}' + '.kt-combo{margin:14px 0 0;padding:12px;border:2px dashed #4eae32;border-radius:12px;background:#f5fbf2;font-size:1.3rem;line-height:1.3;color:#444}' + '.kt-combo__h{display:block;color:#2D3277;font-size:1.45rem;font-weight:800;margin-bottom:2px}' + '.kt-combo__r{display:flex;gap:12px;align-items:center;margin-top:10px}' + '.kt-combo__r img{width:60px;height:60px;object-fit:contain;border-radius:8px;background:#fff;flex:none}' + '.kt-combo__t{flex:1;min-width:0;display:flex;flex-direction:column;gap:2px}' + '.kt-combo__n{font-weight:600;color:#333}' + '.kt-combo__p s{color:#888}.kt-combo__p b{color:#259a38;font-size:1.4rem}' + '.kt-combo__b{flex:none;background:#2D3277;color:#fff;border:0;border-radius:24px;padding:10px 16px;font-weight:700;font-size:1.3rem;cursor:pointer}' + '.kt-combo__b[disabled]{opacity:.6;cursor:wait}' + '@media(max-width:749px){.kt-combo__r{flex-wrap:wrap}.kt-combo__b{width:100%;padding:12px}}' + '.kt-sticky{position:fixed;left:0;right:0;bottom:0;z-index:50;display:flex;gap:8px;align-items:center;padding:8px 10px calc(8px + env(safe-area-inset-bottom));background:#fff;box-shadow:0 -4px 16px rgba(0,0,0,.12);transform:translateY(110%);transition:transform .25s}' + 'html.kt-sticky-on .kt-sticky{transform:none}' + '.kt-sticky__i{flex:1;min-width:0;display:flex;flex-direction:column;gap:1px}' + '.kt-sticky__t{font-size:1.15rem;line-height:1.25;color:#444;display:-webkit-box;-webkit-line-clamp:2;-webkit-box-orient:vertical;overflow:hidden}' + '.kt-sticky__p{font-size:1.5rem;color:#2D3277}' + '.kt-sticky__q{flex:none;display:flex;align-items:center;border:1px solid #cfd2e3;border-radius:22px;height:40px}' + '.kt-sticky__q button{width:30px;height:38px;border:0;background:none;font-size:1.8rem;color:#2D3277;cursor:pointer}' + '.kt-sticky__q span{min-width:18px;text-align:center;font-weight:700;font-size:1.4rem}' + '.kt-sticky__b{flex:none;background:#4eae32;color:#fff;border:0;border-radius:22px;height:42px;padding:0 14px;font-weight:800;font-size:1.35rem}' + '.kt-sticky__b[disabled]{background:#aaa}' + '@media(min-width:750px){.kt-sticky{display:none}}' + '@media(max-width:749px){html.kt-sticky-on .whatsapp-float{bottom:84px}}'; document.head.appendChild(css); var fmt = function (n) { return '$' + Math.round(n).toLocaleString('es-CL'); }; var post = function (items) { return fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ items: items }) }) .then(function (r) { if (!r.ok) throw r; window.location.href = '/cart'; }); }; var curId = function () { var c = form.querySelector('input[name=id]'); return c ? +c.value : 0; }; /* 1) Medios de pago con logos */ var LOGOS = { mp: '<svg class="kt-pay__g" viewBox="0 0 92 30" role="img" aria-label="Mercado Pago"><rect width="92" height="30" rx="4" fill="#00B1EA"/><text x="46" y="19.5" text-anchor="middle" font-family="Arial,sans-serif" font-weight="700" font-size="12.5" fill="#fff">mercado pago</text></svg>', visa: '<svg class="kt-pay__g" viewBox="0 0 48 30" role="img" aria-label="Visa"><rect width="48" height="30" rx="4" fill="#1A1F71"/><text x="24" y="20" text-anchor="middle" font-family="Arial,sans-serif" font-weight="900" font-style="italic" font-size="14" fill="#fff">VISA</text></svg>', mc: '<svg class="kt-pay__g" viewBox="0 0 48 30" role="img" aria-label="Mastercard"><rect x=".5" y=".5" width="47" height="29" rx="4" fill="#fff" stroke="#ddd"/><circle cx="19.5" cy="15" r="9" fill="#EB001B"/><circle cx="28.5" cy="15" r="9" fill="#F79E1B"/><path d="M24 7.2a9 9 0 0 1 0 15.6 9 9 0 0 1 0-15.6z" fill="#FF5F00"/></svg>', deb: '<svg class="kt-pay__g" viewBox="0 0 62 30" role="img" aria-label="Débito"><rect x=".5" y=".5" width="61" height="29" rx="4" fill="#fff" stroke="#ddd"/><rect x="7" y="9" width="16" height="12" rx="2" fill="none" stroke="#2D3277" stroke-width="1.6"/><path d="M7 13h16" stroke="#2D3277" stroke-width="1.6"/><text x="43" y="19" text-anchor="middle" font-family="Arial,sans-serif" font-weight="700" font-size="10" fill="#2D3277">Débito</text></svg>', tr: '<svg class="kt-pay__g" viewBox="0 0 100 30" role="img" aria-label="Transferencia"><rect x=".5" y=".5" width="99" height="29" rx="4" fill="#fff" stroke="#ddd"/><path d="M15 8l8 4H7zM8 13h14v1.5H8zM9 15h2v6H9zm5 0h2v6h-2zm5 0h2v6h-2zM7 22h16v1.5H7z" fill="#4eae32"/><text x="62" y="19" text-anchor="middle" font-family="Arial,sans-serif" font-weight="700" font-size="10" fill="#2D3277">Transferencia</text></svg>' }; var pay = document.createElement('div'); pay.className = 'kt-pay'; pay.innerHTML = '<span class="kt-pay__l"><svg viewBox="0 0 24 24"><path d="M12 2a5 5 0 0 0-5 5v3H6a2 2 0 0 0-2 2v8a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-8a2 2 0 0 0-2-2h-1V7a5 5 0 0 0-5-5zm-3 8V7a3 3 0 0 1 6 0v3z"/></svg>Pago 100% seguro</span>' + '<svg class="kt-pay__g" viewBox="0 0 80 30" role="img" aria-label="Webpay Plus"><rect x=".5" y=".5" width="79" height="29" rx="4" fill="#fff" stroke="#ddd"/><text x="40" y="19.5" text-anchor="middle" font-family="Arial,sans-serif" font-weight="800" font-size="12.5" fill="#6B1D6E">webpay<tspan fill="#E6007E">+</tspan></text></svg>' + LOGOS.visa + LOGOS.mc + LOGOS.deb + LOGOS.mp + LOGOS.tr + '<p class="kt-pay__n">Webpay: crédito, débito y prepago. También Mercado Pago o transferencia (elige «Depósito Bancario» al pagar; tienes 24 h).</p>'; wrap.parentNode.insertBefore(pay, wrap.nextSibling); /* 2) Combos (descuento automático de $5.000 en Shopify al llevar cafetera + Aeroccino 3) */ var meta = (window.ShopifyAnalytics && ShopifyAnalytics.meta && ShopifyAnalytics.meta.product) || {}; var handle = (location.pathname.match(/\/products\/([^/?#]+)/) || [])[1] || ''; var comboBtn = function (b, otherId) { b.addEventListener('click', function () { var id = curId(); if (!id) return; b.disabled = true; var t = b.textContent; b.textContent = 'Agregando…'; post([{ id: id, quantity: 1 }, { id: otherId, quantity: 1 }]).catch(function () { b.disabled = false; b.textContent = t; alert('No se pudo agregar el combo. Intenta de nuevo.'); }); }); }; if (meta.type === 'Cafeteras' && CAFES.indexOf(handle) > -1) { fetch('/products/' + AERO + '.js').then(function (r) { return r.json(); }).then(function (p) { var v = p.variants && p.variants[0]; if (!v || !v.available) return; var im = p.featured_image || ''; im += (im.indexOf('?') < 0 ? '?' : '&') + 'width=160'; var box = document.createElement('div'); box.className = 'kt-combo'; box.innerHTML = '<span class="kt-combo__h">Combo: suma el espumador Aeroccino 3 y ahorra $5.000</span>Leche espumada para cappuccinos y lattes.' + '<div class="kt-combo__r"><img src="' + im + '" alt="" loading="lazy"><div class="kt-combo__t"><span class="kt-combo__n">Aeroccino 3</span>' + '<span class="kt-combo__p"><s>' + fmt(v.price / 100) + '</s> <b>' + fmt(v.price / 100 - 5000) + '</b></span></div>' + '<button type="button" class="kt-combo__b">Agregar ambos</button></div>'; pay.parentNode.insertBefore(box, pay.nextSibling); comboBtn(box.querySelector('button'), v.id); }).catch(function () {}); } else if (handle === AERO) { Promise.all(CAFES.map(function (h) { return fetch('/products/' + h + '.js').then(function (r) { return r.ok ? r.json() : null; }).catch(function () { return null; }); })).then(function (list) { var ok = list.filter(function (p) { return p && p.variants && p.variants[0] && p.variants[0].available; }).slice(0, 3); if (!ok.length) return; var box = document.createElement('div'); box.className = 'kt-combo'; box.innerHTML = '<span class="kt-combo__h">Combo: llévalo con una cafetera y ahorra $5.000</span>El descuento se aplica solo en el carrito.'; ok.forEach(function (p) { var v = p.variants[0], im = p.featured_image || ''; im += (im.indexOf('?') < 0 ? '?' : '&') + 'width=160'; var row = document.createElement('div'); row.className = 'kt-combo__r'; row.innerHTML = '<img src="' + im + '" alt="" loading="lazy"><div class="kt-combo__t"><span class="kt-combo__n"></span><span class="kt-combo__p"><s>' + fmt(v.price / 100) + '</s> <b>' + fmt(v.price / 100 - 5000) + '</b></span></div><button type="button" class="kt-combo__b">Agregar ambos</button>'; row.querySelector('.kt-combo__n').textContent = p.title; box.appendChild(row); comboBtn(row.querySelector('button'), v.id); }); pay.parentNode.insertBefore(box, pay.nextSibling); }); } /* 3) Botón de compra fijo en celular, con cantidad */ var title = document.querySelector('.product__title h1'); var qtyIn = document.querySelector('.product__info-container input[name=quantity]'); var bar = document.createElement('div'); bar.className = 'kt-sticky'; bar.innerHTML = '<div class="kt-sticky__i"><span class="kt-sticky__t"></span><b class="kt-sticky__p"></b></div>' + '<div class="kt-sticky__q"><button type="button" aria-label="Menos">−</button><span>1</span><button type="button" aria-label="Más">+</button></div>' + '<button type="button" class="kt-sticky__b"></button>'; bar.querySelector('.kt-sticky__t').textContent = title ? title.textContent.trim() : ''; var sb = bar.querySelector('.kt-sticky__b'), qb = bar.querySelectorAll('.kt-sticky__q button'), qs = bar.querySelector('.kt-sticky__q span'); var maxQ = function () { var m = qtyIn && parseInt(qtyIn.getAttribute('max'), 10); return m > 0 ? m : 99; }; var getQ = function () { return parseInt(qs.textContent, 10) || 1; }; var setQ = function (n) { n = Math.max(1, Math.min(maxQ(), n)); qs.textContent = n; }; qb[0].addEventListener('click', function () { setQ(getQ() - 1); }); qb[1].addEventListener('click', function () { setQ(getQ() + 1); }); if (!qtyIn) bar.querySelector('.kt-sticky__q').style.display = 'none'; function sync() { var p = document.querySelector('.product__info-container .price-item--sale, .product__info-container .price-item--regular'); bar.querySelector('.kt-sticky__p').textContent = p ? p.textContent.trim() : ''; sb.disabled = btn.disabled; sb.textContent = btn.disabled ? 'Agotado' : 'Agregar'; if (qtyIn) setQ(parseInt(qtyIn.value, 10) || 1); } sync(); document.body.appendChild(bar); sb.addEventListener('click', function () { if (btn.disabled) return; if (qtyIn) { qtyIn.value = getQ(); qtyIn.dispatchEvent(new Event('change', { bubbles: true })); } btn.click(); }); var formsDone = false; function liftForms() { var f = document.querySelector('shopify-forms-embed'), root = f && f.shadowRoot; if (!root || formsDone) return; var s = document.createElement('style'); s.textContent = ':host([data-kt-sticky]) #app-embed[data-current-step=tease]{bottom:140px!important}'; root.appendChild(s); formsDone = true; } var state = null; function chk() { var show = btn.getBoundingClientRect().bottom < 0; if (show === state) return; state = show; document.documentElement.classList.toggle('kt-sticky-on', show); var f = document.querySelector('shopify-forms-embed'); if (f) { liftForms(); if (show) f.setAttribute('data-kt-sticky', ''); else f.removeAttribute('data-kt-sticky'); } if (show) sync(); } window.addEventListener('scroll', chk, { passive: true }); window.addEventListener('resize', chk); chk(); } function init() { try { ktPdp(); } catch (e) {} buildSlides(); startTimers(); sameDay(); rotate(); autoCarousel(); modals(); coverage(); formsIcon(); }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
